import React, { useState, useEffect, useRef } from "react";
import QRCode from "react-qr-code";
import { Download, Printer } from "lucide-react";
import { WHATSAPP_DISPLAY } from "@/lib/pricing";

/**
 * QRCard — bloco imprimível com o QR do site.
 * Usado no hub de panfletos e reaproveitado no rodapé dos panfletos.
 */
export function QRCard({ url, compact = false, className = "" }) {
  const [siteUrl, setSiteUrl] = useState(url || "");
  useEffect(() => {
    if (!url && typeof window !== "undefined") setSiteUrl(window.location.origin);
  }, [url]);

  if (compact) {
    return (
      <div className={"inline-flex items-center gap-3 " + className}>
        <div className="bg-white p-2 rounded-lg border border-[#2C6E49]/20">
          {siteUrl && <QRCode value={siteUrl} size={64} level="M" fgColor="#2C6E49" bgColor="#ffffff" />}
        </div>
        <div className="text-[10pt] leading-tight text-[#2C6E49]" style={{ fontFamily: "Nunito, sans-serif" }}>
          <div className="font-bold">Aponte a câmera</div>
          <div>e acesse o site.</div>
        </div>
      </div>
    );
  }

  const svgToPngDownload = () => {
    const svg = document.querySelector("#qr-download svg");
    if (!svg) return;
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement("canvas");
    canvas.width = 720;
    canvas.height = 720;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    const img = new Image();
    img.onload = () => {
      ctx.drawImage(img, 40, 40, 640, 640);
      const link = document.createElement("a");
      link.download = "caomiar-qr.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    };
    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
  };

  return (
    <div className={"bg-white rounded-3xl border border-brand-cream p-6 md:p-8 shadow-[0_10px_30px_rgba(0,0,0,0.05)] " + className}>
      <div className="grid md:grid-cols-[auto,1fr] gap-6 items-center">
        <div id="qr-download" className="bg-white p-3 rounded-2xl border-2 border-brand-green/25">
          {siteUrl && <QRCode value={siteUrl} size={180} level="M" fgColor="#2C6E49" bgColor="#ffffff" />}
        </div>
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-brand-brown">QR Code do site</div>
          <div className="font-display font-bold text-2xl md:text-3xl text-brand-green mt-1">
            Cole na vitrine, imprima no panfleto.
          </div>
          <p className="text-brand-brownDark mt-2 text-sm">
            Aponte a câmera do celular e o site abre direto — ideal para pet shops, cafés
            pet-friendly e murais do prédio. WhatsApp: {WHATSAPP_DISPLAY}.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={svgToPngDownload}
              data-testid="qr-download"
              className="inline-flex items-center gap-2 rounded-full bg-brand-green hover:bg-brand-greenDark text-brand-cream px-5 py-2.5 font-bold text-sm transition-transform hover:-translate-y-0.5"
            >
              <Download size={16} /> Baixar PNG
            </button>
            <button
              onClick={() => window.print()}
              data-testid="qr-print"
              className="inline-flex items-center gap-2 rounded-full border-2 border-brand-green text-brand-green hover:bg-brand-green hover:text-brand-cream px-5 py-2.5 font-bold text-sm transition-colors"
            >
              <Printer size={16} /> Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QRCard;
